export const URLS = {
  AUTH_ALERTS: 'lostSalesOpportunities/alerts',
  AUTH_ALERT: 'lostSalesOpportunities/alerts/:id',
  AUTH_ALERT_MANAGEMENT: 'lostSalesOpportunities/alertManagement'
}
